/* Outdoors Nordic – köp-1-få-1: offer-produkter bara i par (omgång 53, Victor 2026-10-23).

   Offer-produkterna (taggen bogo-offer, utom gåvor med taggen gava) är prissatta för TVÅ par
   och har en automatisk BxGy-rabatt "köp 1, få 1". Ligger ett udda antal i korgen utlöses
   rabatten inte för det sista paret, och kunden betalar tvåparspris för ett par (order #65970).

   Regeln gäller SUMMAN av enheter per offer-produkt, inte varje rad: två färger med ett par
   var (1 + 1) är rätt. Nätet nedan körs
     - när sidan laddas och korgen redan har en offer-produkt,
     - efter varje lyckat /cart/add, /cart/change och /cart/update (temat, appar, allt som
       går via fetch), och efter cart:update från andra håll,
     - före kassan: trycket på "Till kassan" väntar tills korgen är kontrollerad och rättad.
   Udda summa rättas: upp till närmaste jämna tal, utom när kunden själv minskat från 4 eller
   mer (då ned, så att minus-knappen går 4 → 2 och inte fastnar). Summan 1 blir alltid 2.
   Ändringen syns direkt i lådan (sektionerna skickas med) och kunden får ett kort besked.

   Utan JavaScript stänger varukorgen själv av kassaknappen vid udda summa (cart-summary). */
(function () {
  'use strict';
  if (window.__onPair) return;
  var el = document.getElementById('on-bogo-pair');
  if (!el) return;
  var CFG;
  try { CFG = JSON.parse(el.textContent); } catch (e) { return; }
  var TAG = CFG.tag || 'bogo-offer', SKIP = CFG.skip || 'gava', T = CFG.t || {};
  window.__onPair = { enforce: function () { return enforce(); } };

  var origFetch = window.fetch;
  var OFFER = {};   // product_id -> true/false (känt)
  (CFG.ids || []).forEach(function (id) { OFFER[String(id)] = true; });
  if (CFG.cur) OFFER[String(CFG.cur)] = true;
  try {
    var mem = JSON.parse(sessionStorage.getItem('onPairTags') || '{}');
    Object.keys(mem).forEach(function (k) { if (OFFER[k] === undefined) OFFER[k] = mem[k]; });
  } catch (e) {}
  function remember() { try { sessionStorage.setItem('onPairTags', JSON.stringify(OFFER)); } catch (e) {} }

  /* Har korgen (senast kända) en offer-produkt? Från servern vid laddning, sedan från varje kontroll. */
  var HAS = (CFG.ids || []).length > 0;
  function anyOffer() { return HAS || (!!CFG.cur && !!running); }

  function cartJs() {
    return origFetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  /* Okända produkter slås upp på produktens egen JSON (taggarna finns där). */
  function classify(cart) {
    var need = {};
    (cart.items || []).forEach(function (it) { if (OFFER[String(it.product_id)] === undefined) need[it.product_id] = it.handle; });
    var ids = Object.keys(need);
    if (!ids.length) return Promise.resolve(cart);
    return Promise.all(ids.map(function (id) {
      return origFetch('/products/' + need[id] + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var tags = (p && p.tags) || [];
          if (typeof tags === 'string') tags = tags.split(/\s*,\s*/);
          OFFER[id] = tags.indexOf(TAG) > -1 && tags.indexOf(SKIP) === -1;
        })['catch'](function () { /* okänt: ingen gissning, ingen ändring */ });
    })).then(function () { remember(); return cart; });
  }

  /* Summa per offer-produkt. Rabatterade rader kan stå som flera poster med samma line key. */
  function sums(cart) {
    var s = {}, lines = {};
    (cart.items || []).forEach(function (it) {
      var pid = String(it.product_id);
      if (!OFFER[pid]) return;
      s[pid] = (s[pid] || 0) + it.quantity;
      lines[pid] = lines[pid] || {};
      lines[pid][it.key] = (lines[pid][it.key] || 0) + it.quantity;
    });
    return { s: s, lines: lines };
  }

  var last = null; // senast kända summor, för att se om kunden minskade
  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (c) {
      var id = c.getAttribute('data-section-id') || c.getAttribute('section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function note(text) {
    if (!text) return;
    var n = document.getElementById('on-pair-note');
    if (!n) {
      n = document.createElement('div');
      n.id = 'on-pair-note';
      n.className = 'on-pair-note';
      n.setAttribute('role', 'status');
      n.setAttribute('aria-live', 'polite');
      document.body.appendChild(n);
    }
    n.textContent = text;
    n.hidden = false;
    clearTimeout(n._t);
    n._t = setTimeout(function () { n.hidden = true; }, 7000);
  }

  function mark(has) { HAS = !!has; document.documentElement.classList.toggle('on-pair-cart', HAS); }

  /* En rättning per udda produkt, en rad i taget på line key. Nekas ändringen (t.ex. lagret
     räcker inte) provas nästa rad, och till sist att runda nedåt. */
  function change(key, q, secs) {
    var body = { id: key, quantity: q };
    if (secs.length) { body.sections = secs.join(','); body.sections_url = window.location.pathname; }
    return origFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('change'); return r.json(); });
  }
  function fix(cart) {
    var st = sums(cart), odd = [];
    Object.keys(st.s).forEach(function (pid) { if (st.s[pid] % 2) odd.push(pid); });
    mark(Object.keys(st.s).length > 0);
    if (!odd.length) { last = st.s; return Promise.resolve(false); }
    var secs = sectionIds();
    var chain = Promise.resolve(), resp = null, ned = false;
    odd.forEach(function (pid) {
      var sum = st.s[pid], keys = st.lines[pid], ks = Object.keys(keys);
      var down = last && last[pid] !== undefined && sum < last[pid] && sum >= 3;
      // Försöksordning: vid minskning den största raden ned, annars varje rad upp och sist ned.
      var tries = [];
      if (down) {
        var big = ks[0]; ks.forEach(function (k) { if (keys[k] > keys[big]) big = k; });
        tries.push([big, keys[big] - 1, true]);
      }
      ks.forEach(function (k) { tries.push([k, keys[k] + 1, false]); });
      if (!down) tries.push([ks[0], keys[ks[0]] - 1, true]);
      chain = chain.then(function () {
        var i = 0;
        var next = function () {
          if (i >= tries.length) throw new Error('fix');
          var t = tries[i++];
          return change(t[0], t[1], secs).then(function (j) { resp = j; if (t[2]) ned = true; }, next);
        };
        return next();
      });
    });
    return chain.then(function () {
      var fresh = resp, now = sums(fresh).s, ok = true;
      Object.keys(now).forEach(function (pid) { if (now[pid] % 2) ok = false; });
      last = now;
      mark(Object.keys(now).length > 0);
      if (ok) note(ned ? T.down : T.added);
      /* Lådan ritas om men öppnas inte av sig själv: är den stängd tas auto-open bort
         under händelsen (Horizon öppnar annars lådan vid varje cart:update). */
      var dr = document.querySelector('cart-drawer-component');
      var dlg = dr && dr.querySelector('dialog');
      var hold = dr && dr.hasAttribute('auto-open') && !(dlg && dlg.open);
      if (hold) dr.removeAttribute('auto-open');
      try {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: fresh, sourceId: 'on-bogo-pair', data: { source: 'on-bogo-pair', itemCount: fresh.item_count, sections: fresh.sections || null } }
        }));
      } catch (e) {}
      if (hold) dr.setAttribute('auto-open', '');
      return true;
    });
  }

  var running = null, again = false;
  function enforce() {
    if (running) { again = true; return running; }
    running = cartJs().then(classify).then(fix).then(function (changed) {
      running = null;
      if (again) { again = false; return enforce(); }
      return changed;
    }, function (err) { running = null; again = false; throw err; });
    return running;
  }
  function soon() { setTimeout(function () { enforce()['catch'](function () {}); }, 0); }

  /* Allt som ändrar korgen via fetch kontrolleras efteråt. Våra egna anrop går via origFetch. */
  window.fetch = function (input) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update)/.test(url)) {
      p.then(function (res) { if (res && res.ok) soon(); }, function () {});
    }
    return p;
  };
  document.addEventListener('cart:update', function (e) {
    var d = e && e.detail && e.detail.data;
    if (d && d.source === 'on-bogo-pair') return;
    soon();
  });

  /* Före kassan. Bara när korgen har en offer-produkt; annars orört. Formulärets värden
     (antal som ännu inte skickats, kommentar) sparas först, sedan kontrolleras korgen och
     kunden skickas till kassan på marknadens språk. */
  function root() { try { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; } catch (e) { return '/'; } }
  function flush(trigger) {
    var f = trigger && (trigger.form || (trigger.getAttribute && document.getElementById(trigger.getAttribute('form') || '')));
    if (!f || !/\/cart(\?|$)/.test(f.action || '')) return Promise.resolve();
    var fd = new FormData(f), body = new FormData(), n = 0;
    fd.forEach(function (v, k) { if (k === 'updates[]' || k === 'note' || /^attributes\[/.test(k)) { body.append(k, v); n++; } });
    if (!n) return Promise.resolve();
    return origFetch(root() + 'cart/update.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body }).then(function () {}, function () {});
  }
  function toCheckout(trigger) {
    if (trigger) trigger.setAttribute('aria-busy', 'true');
    var go = function () { window.location.href = root() + 'checkout'; };
    var run = function (n) {
      return enforce().then(function () { return cartJs(); }).then(function (cart) {
        var st = sums(cart), bad = Object.keys(st.s).some(function (pid) { return st.s[pid] % 2; });
        if (bad && n < 2) return run(n + 1);
        if (bad) throw new Error('odd');
        go();
      });
    };
    flush(trigger).then(function () { return run(0); })['catch'](function () {
      if (trigger) trigger.removeAttribute('aria-busy');
      note(T.error || T.block);
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('button[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
    if (!t || !anyOffer()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    toCheckout(t);
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target, s = e.submitter;
    if (!anyOffer() || !f || !f.action || !/\/cart(\?|$)/.test(f.action)) return;
    if (!(s && s.name === 'checkout') && !(f.querySelector && f.querySelector('input[name="checkout"]'))) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    toCheckout(s);
  }, true);

  if ((CFG.ids || []).length) soon();
})();
